import React from "react";
import FilterDropdown from "../../components/ui-components/FilterDropdown";

// budgetOptions maps the None / Whole-project sentinels plus the supplied budgets to
// FilterDropdown's contract ({ value, label }). "" = no budget selected (unchanged
// spend view); "0" is a sentinel meaning budget_id=0 / the whole-project pseudo-budget
// (matches the backend's whole-project cost source convention); everything else is a
// real budget id.
export function budgetOptions(budgets = []) {
  return [
    { value: "", label: "None" },
    { value: "0", label: "Whole project (Total)" },
    ...budgets.map((b) => ({ value: String(b.id), label: b.name })),
  ];
}

// BudgetSelect — lets the analyzer scope down to one budget's burn-up (BUD1).
export default function BudgetSelect({ value, onChange, budgets = [] }) {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-[11px] font-semibold uppercase tracking-[0.04em] text-text-3">Budget</label>
      <FilterDropdown
        ariaLabel="Budget"
        value={value}
        onChange={onChange}
        minWidth={240}
        height={40}
        options={budgetOptions(budgets)}
      />
    </div>
  );
}
